import MojitoCore from 'mojito/core';

const log = MojitoCore.logger.get('FavoritesServiceFactory');

const voidResponder = () => {
    log.warn('favoritesService instance is missing.');
    return Promise.reject();
};

const NULL_SERVICE = {
    fetchFavoriteEventIds: voidResponder,
    addFavoriteEventId: voidResponder,
    removeFavoriteEventId: voidResponder,
};

/**
 * Singleton object that receives favorites config and spawn service instance.
 *
 * @class ServiceFactory
 * @name serviceFactory
 * @memberof Mojito.Services.Favorites
 */
class ServiceFactory {
    constructor() {
        this.service = NULL_SERVICE;
    }

    /**
     * Init factory.
     *
     * @function init
     *
     * @param {Mojito.Services.Favorites.FavoritesConfig} config - Favorites config.
     *
     * @memberof Mojito.Services.Favorites.serviceFactory
     */
    init({ service }) {
        this.service = service;
    }

    /**
     * Service getter.
     *
     * @function getService
     *
     * @returns {Mojito.Services.Favorites.AbstractFavoritesService} Favorites service instance.
     *
     * @memberof Mojito.Services.Favorites.serviceFactory
     */
    getService() {
        return this.service;
    }
}

export default new ServiceFactory();
